module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/transform.js
// module id = 1052
// module chunks = 0